import React, { useContext, useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SingleCategory from "../../../../components/general/singlecategory/SingleCategory";
import "../../../../assets/css/customer/subscreens/home/Categoriess.css";
import MyContext from "../../../../contexts/AppContext";

const Categories = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles, setSelectedCategory } =
    useContext(MyContext);
  const [categories, setCategories] = useState([]);

  const viewAllCategories = () => {
    axios
      .get(`${baseUrl}/customer/category/viewAllCategories`)
      .then((response) => {
        setCategories(response.data.categories);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllCategories();
  }, []);


  return (
    <section className="categories-section">
      <Container>
        <div className="category-section-header">
          <h2 className="category-section-title">SHOP BY CATEGORY</h2>
          <div className="title-underline"></div>
        </div>

        <Row className="categories-grid justify-content-center mx-0">
          {" "}
          {categories.slice(0, 4).map((category) => (
            <SingleCategory
              key={category.id}
              category={{
                id: category.id,
                name: category.category_name,
                defaultImage: `${baseUrlForFiles}/${category.category_image}`,
                hoverImage: `${baseUrlForFiles}/${category.category_image}`,
              }}
            />
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Categories;
